export const KAKAO_PIXEL = {
  // KAKAO PIXEL 추적 페이지(메인 제외)
  page: [
    '/order/cart',
    '/goods/view',
    '/order/payComplete',
    '/member/register',
  ],
}